import { useTranslation } from 'react-i18next'
import { TypedTFunctionInterface } from '../types/typed-t-function-interface'

export const useTypedTranslation = (
  ...args: Parameters<typeof useTranslation>
) => {
  const { t, i18n } = useTranslation(...args)
  return { t: t as unknown as TypedTFunctionInterface, i18n }
}
